import { ResetPasswordScreen } from "@/features/auth";

export default ResetPasswordScreen;
